import * as Types from './messaging_gql.generated';

import { MessageFragment, ConversationFragment, CoachFragment, MemberFragment } from './fragments.generated';
import { gql } from 'graphql.macro';
import { MessageFragmentDoc, ConversationFragmentDoc, CoachFragmentDoc, MemberFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
export type OnNewMessageSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnNewMessageSubscription = (
  { __typename?: 'Subscriptions' }
  & { onNewMessage?: Types.Maybe<(
    { __typename?: 'MessageNode' }
    & MessageFragment
  )> }
);


export const OnNewMessageDocument = gql`
    subscription onNewMessage {
  onNewMessage {
    ...message
  }
}
    ${MessageFragmentDoc}`;
export type OnNewMessageSubscriptionResult = Apollo.SubscriptionResult<OnNewMessageSubscription>;